import React, {useMemo} from 'react';
import styles from './DatePicker.module.scss';
import './customStyle.css';
import { DatePicker } from 'antd';
import moment from 'moment';

type Props = {
  label: string;
  value: string;
  className?: string;
  onChange: (date: any, dateString: any) => void
  disabledDate?: (currentDate: any) => boolean
  dateFormat?: string;
};

function OpDatePicker(props: Props) {
  const { label, value, dateFormat = 'MM.DD.YYYY', onChange, className, disabledDate } = props;

  const classes = useMemo(() => {
    const classes = [styles.wrapper, className];
    
    return classes.join(' ').trim();
  }, [className]);

  const today = new Date();
  return (
    <div className={classes}>
      <label className={styles.label}>{label}</label>
      <DatePicker 
        onChange={onChange}
        defaultValue={moment(today, dateFormat)}
        value={value ? moment(value, dateFormat) : null}
        disabledDate={disabledDate}
        format={dateFormat}/>
    </div>
  );
};

export default OpDatePicker;